'use client'
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import 'dayjs/locale/zh-cn';
const AntConfigProvider = ({ children }: any) => {
    return (
        <ConfigProvider
            locale={zhCN}
            theme={{
                token: {
                    colorPrimary: '#f64b4b',  // 修改全局主色
                },
            }}
        >
            {children}
        </ConfigProvider>
    )
}

export default AntConfigProvider